package com.sddamico.swigmore.ds.poll

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.core.Card
import com.sddamico.swigmore.ds.core.CardVariant
import com.sddamico.swigmore.ds.core.StatusTag
import com.sddamico.swigmore.ds.core.SubmissionStatus
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.forms.Button
import com.sddamico.swigmore.ds.forms.ButtonStyle
import com.sddamico.swigmore.ds.forms.ButtonVariant
import com.sddamico.swigmore.ds.typeBody
import com.sddamico.swigmore.ds.typeCaps
import com.sddamico.swigmore.ds.typeMono
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private const val SUBMISSION_COLUMNS = "minmax(0,1.4fr) minmax(0,1fr) auto"

/** The commissioner's ballot table: header band, [rows] slot, and a mono [footer] line. */
@Composable
fun SubmissionTable(modifier: Modifier = Modifier, footer: String? = null, rows: @Composable () -> Unit) {
  Card(modifier.css("overflow" to "hidden"), variant = CardVariant.Plain, padding = "0") {
    Div(
      attrs = Modifier.typeCaps("9px", ".16em")
        .css("display" to "grid", "grid-template-columns" to SUBMISSION_COLUMNS, "gap" to "12px",
          "padding" to "10px 16px", "background" to SwColor.creamDeep)
        .toAttrs()
    ) {
      Span { Text("Owner") }
      Span { Text("Submitted") }
      Span(attrs = Modifier.css("text-align" to "right").toAttrs()) { Text("Actions") }
    }
    rows()
    if (footer != null) {
      Div(
        attrs = Modifier.typeMono("11px").css("padding" to "12px 16px", "border-top" to "1px solid ${SwColor.ruleOnCream}",
          "opacity" to ".7", "text-transform" to "uppercase").toAttrs()
      ) { Text(footer) }
    }
  }
}

/** One owner's ballot in the [SubmissionTable]: team, their No. 1, timestamp + status, EDIT / DELETE. */
@Composable
fun SubmissionRow(
  team: String,
  topPick: String,
  submittedAt: String,
  status: SubmissionStatus,
  onEdit: (() -> Unit)? = null,
  onDelete: (() -> Unit)? = null,
  disabled: Boolean = false,
) {
  Div(
    attrs = Modifier.css("display" to "grid", "grid-template-columns" to SUBMISSION_COLUMNS, "gap" to "12px",
      "align-items" to "center", "padding" to "11px 16px", "border-top" to "1px solid ${SwColor.ruleOnCream}").toAttrs()
  ) {
    Div(attrs = Modifier.css("min-width" to "0").toAttrs()) {
      Div(attrs = Modifier.typeCaps("13px", "0").toAttrs()) { Text(team) }
      Div(attrs = Modifier.typeBody("12px", 500, "normal").css("opacity" to ".7", "margin-top" to "2px").toAttrs()) { Text("No. 1: $topPick") }
    }
    Div {
      Div(attrs = Modifier.typeMono("11px").toAttrs()) { Text(submittedAt) }
      StatusTag(status, Modifier.css("margin-top" to "4px"))
    }
    Div(attrs = Modifier.css("display" to "flex", "gap" to "6px").toAttrs()) {
      Button("Edit", variant = ButtonVariant.Outline, style = ButtonStyle.CapsSm, disabled = disabled, onClick = onEdit)
      Button("Delete", variant = ButtonVariant.Field, style = ButtonStyle.CapsSm, disabled = disabled, onClick = onDelete)
    }
  }
}
